var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEducatorsTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9835 39.7296C65.7552 26.378 63.8645 -2.68016 39.5976 0.199308C15.3306 3.07877 -0.0020954 36.3266 1.00047 47.8454C2.00303 59.3642 9.52091 80.8311 44.1093 77.6896C78.6976 74.5481 84.2117 53.0812 74.9835 39.7296Z",
    fill: "url(#paint0_linear_46_528)",
    fillOpacity: 0.36
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9499 19.75H38.619C36.3819 19.75 34.5688 21.5634 34.5688 23.8001V33.3221C35.5907 33.83 36.6948 34.3792 37.7254 34.8914L39.3021 31.7366C40.2568 29.8289 42.5842 29.0537 44.4913 30.0068C46.4024 30.9632 47.1768 33.2841 46.2201 35.1956L43.4093 40.8185C43.4839 41.5627 43.4177 42.313 43.2079 43.0391H45.0636L40.1692 56.4977C39.8788 57.296 40.4401 58.2275 41.3811 58.2275C41.9071 58.2275 42.4019 57.9029 42.5919 57.3785L47.8066 43.0391H48.7099L53.9776 57.3829C54.1693 57.9046 54.6628 58.2275 55.1885 58.2275C56.0677 58.2275 56.7122 57.3493 56.3976 56.4943L51.4562 43.0391H57.9499C60.1866 43.0391 62 41.2256 62 38.9889V23.8001C62 21.5634 60.1866 19.75 57.9499 19.75ZM55.1878 37.5166H49.4041C48.6925 37.5166 48.1151 36.9392 48.1151 36.2275C48.1151 35.5152 48.6925 34.9384 49.4041 34.9384H55.1878C55.9001 34.9384 56.4769 35.5152 56.4769 36.2275C56.4769 36.9392 55.9001 37.5166 55.1878 37.5166ZM55.1878 32.6836H49.4041C48.6925 32.6836 48.1151 32.1069 48.1151 31.3945C48.1151 30.6829 48.6925 30.1055 49.4041 30.1055H55.1878C55.9001 30.1055 56.4769 30.6829 56.4769 31.3945C56.4769 32.1069 55.9001 32.6836 55.1878 32.6836ZM55.1878 27.8513H41.3811C40.6687 27.8513 40.092 27.2739 40.092 26.5622C40.092 25.8506 40.6687 25.2732 41.3811 25.2732H55.1878C55.9001 25.2732 56.4769 25.8506 56.4769 26.5622C56.4769 27.2739 55.9001 27.8513 55.1878 27.8513Z",
    fill: "#821C6B",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6808 42.4862C40.9138 41.8037 40.9121 41.0907 40.7154 40.4401L43.9145 34.0425C44.2328 33.4057 43.9749 32.6312 43.3381 32.313C42.7017 31.9944 41.9272 32.2526 41.6086 32.8894L38.8801 38.3457C37.2493 37.5337 34.7716 36.3017 32.7755 35.3091C30.9185 34.3856 29.5932 33.5574 27.3319 33.5574H26.1929C27.9536 33.5574 29.525 32.747 30.5536 31.4788C31.3384 30.5137 31.8077 29.2837 31.8077 27.9433C31.8077 24.8418 29.2941 22.3281 26.1923 22.3281C23.0918 22.3281 20.5781 24.8418 20.5781 27.9433C20.5781 29.4327 21.1582 30.7863 22.1045 31.7906C23.1277 32.8786 24.5809 33.5574 26.1919 33.5577C24.0321 33.5577 21.9206 34.4329 20.4016 35.9559C18.853 37.5005 18 39.5583 18 41.7503V45.8925C18 47.6757 19.1578 49.193 20.7614 49.7328V56.9381C20.7614 57.6501 21.3385 58.2272 22.0505 58.2272H30.3347C31.0467 58.2272 31.6238 57.6501 31.6238 56.9381V42.4546C32.846 43.0656 34.4517 43.8682 35.7508 44.5181C36.6615 44.9733 37.7257 45.0143 38.6747 44.6282C39.621 44.2388 40.3505 43.4637 40.6758 42.5013C40.6774 42.4962 40.6791 42.4912 40.6808 42.4862Z",
    fill: "#821C6B",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_528",
    x1: -5.23708,
    y1: 9.63185,
    x2: 81.4697,
    y2: 50.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#821C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#821C6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(18 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEducatorsTotal);
export default __webpack_public_path__ + "static/media/ic-educators-total.ec84be99bd1485fe010e91e23bf54159.svg";
export { ForwardRef as ReactComponent };